import { DATE_RANGE_CONJUNCTION } from '@modules/common/components/DateRangePicker/constants';
import { Dayjs } from 'dayjs';
import { DATE_FORMAT } from 'v2/core/date/date';

export function formatDateRange(from: Dayjs, to: Dayjs): string {
  const fromDateString = from.tz().format(DATE_FORMAT);
  const toDateString = to.tz().format(DATE_FORMAT);

  if (fromDateString === toDateString) {
    return fromDateString;
  }

  if (to.diff(from, 'day') === 1) {
    return fromDateString;
  }

  return `${fromDateString}${DATE_RANGE_CONJUNCTION}${toDateString}`;
}
